import {
	Badge,
	Checkbox,
	Stack,
	Tag,
	TextStyle,
	Tooltip,
} from "@shopify/polaris"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

const ProductsSelectorRow = ({ checked, setSelectedProductsIds, ...props }) => {
	const {
		id,
		title,
		images,
		tags,
		variants,
		originalPrice,
		convertedPrice,
		roundedConvertedPrice,
	} = props.product
	const [_checked, _setChecked] = useState(false)
	const { t } = useTranslation()

	const onCheckChange = (change) => {
		_setChecked(change)

		if (change) {
			setSelectedProductsIds((prev) => [...prev, id])
		} else {
			setSelectedProductsIds((prev) =>
				prev.filter((productId) => productId !== id),
			)
		}
	}

	useEffect(() => {
		_setChecked(checked)
	}, [checked])

	return (
		<div
			key={id}
			style={{
				display: "flex",
				gap: "0.5rem",
				padding: "1rem",
				borderBottom: "1px solid #ccc",
			}}
		>
			<Checkbox
				checked={_checked}
				onChange={(change) => onCheckChange(change)}
			/>

			<div style={{ flex: "0 0 auto" }}>
				<img
					loading="lazy"
					referrerPolicy="no-referrer"
					src={images?.[0]?.src || ""}
					style={{ width: "5rem", borderRadius: "0.3125rem" }}
				/>
			</div>

			<div
				style={{
					display: "flex",
					flexDirection: "column",
					gap: "0.3rem",
					flex: "1",
					minWidth: "0",
				}}
			>
				<div
					style={{ display: "flex", justifyContent: "space-between" }}
				>
					<TextStyle variation="strong">{title}</TextStyle>
				</div>

				<Tooltip
					content={
						<div
							style={{
								padding: "0.4rem 0.7rem",
								fontSize: "0.85rem",
								display: "flex",
								flexDirection: "column",
								gap: "0.3rem",
							}}
						>
							<div>
								{t("multiple.price_before_conversion")}{" "}
								<b>{originalPrice}</b>
							</div>
							<div>
								{t("multiple.price_after_conversion")}{" "}
								<b>{convertedPrice}</b>
							</div>
							<div>
								{t("multiple.price_after_rounding")}{" "}
								<b>{roundedConvertedPrice}</b>
							</div>
						</div>
					}
				>
					<Badge size="small" status="success">
						{roundedConvertedPrice}
					</Badge>
				</Tooltip>

				<p style={{ fontSize: "0.7rem", color: "#aaa" }}>
					Created:{" "}
					{new Date(props.product.created_at).toLocaleString()}
				</p>

				<Stack spacing="extraTight">
					{tags.map((tag) => (
						<Tag key={tag}>{tag}</Tag>
					))}
				</Stack>
			</div>
		</div>
	)
}

export default React.memo(ProductsSelectorRow)
